"use client";

import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Enquiry() {
  return <section id="cta" data-nav="light" className="relative bg-background text-foreground py-16 sm:py-20 lg:py-24 border-t border-border">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12 max-w-7xl">
        {/* Metal Rating Plate Frame Motif */}
        <div className="border border-border p-2 sm:p-3 bg-muted/40">
          <div className="border border-border bg-background p-6 sm:p-10 lg:p-14 relative">
            {/* Blueprint corner registration ticks */}
            <div className="hidden sm:block absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-foreground -translate-x-0.5 -translate-y-0.5 pointer-events-none" />
            <div className="hidden sm:block absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-foreground translate-x-0.5 -translate-y-0.5 pointer-events-none" />
            <div className="hidden sm:block absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-foreground -translate-x-0.5 translate-y-0.5 pointer-events-none" />
            <div className="hidden sm:block absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-foreground translate-x-0.5 translate-y-0.5 pointer-events-none" />

            <div className="max-w-3xl flex flex-col items-start text-left">
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight uppercase leading-tight text-foreground">
                Find the Right Used Mechanical Bull
              </h2>

              <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed font-sans">
                A used mechanical bull should be evaluated as an individual piece of equipment. Look beyond the headline price and compare the exact machine&apos;s condition, controller, inflatable, included equipment, known history, parts availability and delivery requirements.
              </p>

              <p className="mt-3 text-base sm:text-lg text-muted-foreground leading-relaxed font-sans">
                Browse the current used mechanical bulls for sale, review the individual listings, and send an enquiry when you find a machine that fits your budget and intended use.
              </p>

              {/* Action Buttons */}
              <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-auto">
                <Button asChild size="lg" className="h-12 px-8 rounded-none bg-primary text-primary-foreground font-serif uppercase tracking-wider text-base font-semibold transition-[color,background-color,border-color] hover:bg-primary/90">
                  <Link to="#" className="inline-flex items-center justify-center gap-2">
                    <span>Shop Used Mechanical Bulls</span>
                    <ArrowRight className="size-4" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg" className="h-12 px-8 rounded-none border border-foreground bg-transparent text-foreground font-serif uppercase tracking-wider text-base font-semibold transition-[color,background-color,border-color] hover:bg-foreground hover:text-background">
                  <Link to="/RequestQuotePage" className="inline-flex items-center justify-center gap-2">
                    <span>Enquire About A Used Bull</span>
                  </Link>
                </Button>
              </div>

              <div className="mt-6 flex items-center gap-2 text-xs font-mono text-muted-foreground">
                <Mail className="size-3.5" />
                <span>Direct inquiries:</span>
                <a href="mailto:sales@mechanicalbullshop.com" className="text-foreground hover:underline">
                  sales@mechanicalbullshop.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}